<template>
  <b-container fluid>
    <b-card
      class="m-4"
      header="Lista de escalas"
      header-text-variant="white"
      header-tag="header"
      header-bg-variant="success"
      footer-tag="footer"
    >
      <b-card-text>
        <b-row class="mb-3">
          <b-col>
            Filtro
            <b-form-input v-model="filtro"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-table
              id="tabelaEscalas"
              :items="myProvider"
              :per-page="perPage"
              :current-page="currentPage"
              :fields="campos_tabela"
              :filter="filtro"
              small
            >
              <template v-slot:cell(mes)="data">
                <!-- `data.value` is the value after formatted by the Formatter -->
                <p>
                  {{ new Date(data.value) | moment("MM/YYYY") }}
                </p>
              </template>
              <template v-slot:cell(acoes)="row">
                <!-- `data.value` is the value after formatted by the Formatter -->
                <b-row align-h="end" class="mr-1">
                  <b-button
                    v-if="hasPermission('visualizarEscala')"
                    size="sm"
                    variant="primary"
                    @click="exibeEscala(row.item.id)"
                  >
                    <b-icon icon="search"></b-icon>
                  </b-button>
                  <b-button
                    v-if="hasPermission('editarEscala')"
                    size="sm"
                    class="ml-2"
                    variant="warning"
                    :to="`/escalas/editar/${row.item.id}`"
                  >
                    <b-icon icon="pencil"></b-icon>
                  </b-button>
                  <b-button
                    v-if="hasPermission('excluirEscala')"
                    size="sm"
                    class="ml-2"
                    variant="danger"
                    @click="excluiEscala(row.item.id)"
                  >
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </b-row>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="d-flex justify-content-center">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card-text>
      <template v-slot:footer>
        <b-button
          v-if="hasPermission('criarEscala')"
          variant="success"
          to="escalas/adicionar"
          >Nova escala</b-button
        >
      </template>
    </b-card>

    <!-- aqui é modal onde vai aparecer a escala -->
    <b-modal id="modal-escala" size="xl">
      <template #default>
        <PreviaEscala :escala="escala" :editavel="false" ref="previa" />
      </template>
      <template #modal-footer="{ cancel }">
        <b-button variant="danger" @click="cancel()">
          Fechar
        </b-button>
        <b-button variant="primary" @click="download()">
          Download
        </b-button>
      </template>
    </b-modal>
  </b-container>
</template>

<script>
import jspdf from "jspdf";
import PreviaEscala from "@/components/escalas/PreviaEscala.vue";
import mixinToast from "@/mixins/mixinToast.js";
import permissionsMixin from "@/mixins/permissionsMixin.js";

export default {
  components: {
    PreviaEscala,
  },
  mixins: [mixinToast, permissionsMixin],
  data() {
    return {
      filtro: "",
      escala: null,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      campos_tabela: [
        { key: "id", label: "ID" },
        { key: "tipoEscala.descricao", label: "Tipo" },
        {
          key: "criadoPor.login",
          label: "Criado Por",
          class: "d-none d-sm-block",
        },
        { key: "mes", label: "Mês" },
        { key: "acoes", label: "Ações", thClass: "cabecalho-direita" },
      ],
    };
  },
  methods: {
    download() {
      const doc = new jspdf("landscape", "mm", "a4");
      const ref = this;
      const table = this.$refs.previa.$el.querySelector("table");
      table.style = "letter-spacing: 0.2px";
      const width = table.scrollWidth;
      const alturaA4_pts = 841.89;

      doc.html(table, {
        html2canvas: {
          // insert html2canvas options here, e.g.
          //letterRendering: true,
          //scale: 0.3,
          scale: (alturaA4_pts * 0.33) / width,
          //scale: width / 842,
        },
        callback: function(doc) {
          doc.save(`escala_${ref.escala.id}.pdf`);
        },
        x: 10,
        y: 10,
      });
    },
    exibeEscala(id_escala) {
      this.$http.get("/escala/" + id_escala).then((result) => {
        this.escala = result.data;
        this.$bvModal.show("modal-escala");
      });
    },
    excluiEscala(id_escala) {
      this.$bvModal
        .msgBoxConfirm(
          "Tem certeza de que deseja excluir a escala " + id_escala + "?",
          {
            title: "Confirmação",
            okVariant: "danger",
            okTitle: "Sim",
            cancelTitle: "Não",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.$http.delete("/escala/" + id_escala).then((result) => {
              if (result.data.success) {
                this.$root.$emit("bv::refresh::table", "tabelaEscalas");
              }

              this.exibeToast(result.data.success, result.data.message);
            });
          }
        });
    },
    myProvider(ctx) {
      if (ctx.filter.length > 3 || ctx.filter == "")
        return this.$http
          .get(
            "/escala?page=" +
              ctx.currentPage +
              "&limit=" +
              ctx.perPage +
              "&filter=" +
              ctx.filter
          )
          .then((result) => {
            this.totalRows = result.data.totalRows;
            console.log(result.data.dados);
            return result.data.dados;
          });
    },
  },
};
</script>

<style>
.cabecalho-direita {
  text-align: right;
  padding-right: 0.9rem !important;
}

#modal-escala .modal-dialog {
  width: 98% !important;
  min-width: 98% !important;
  height: 90%;
  margin: 0.2;
  padding: 0;
}

#modal-escala .modal-content {
  height: auto;
  min-height: 90%;
}
/* .modal {
  padding: 0 !important;
}
.modal .modal-dialog {
  width: 100%;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal .modal-body {
  overflow-y: auto;
} */
</style>
